<template>
  <div ref="unknowPreview" class="pre" :class="previewClass">{{msg}}</div>
</template>

<script>
export default {
  name: "unknowPreview",
  data() {
    return {
      msg: "正在加载..."
    };
  },
  created() {
    // console.log("初始化unknow预览组件");
    setTimeout(() => {
      this.msg = this.previewData.message
        ? this.previewData.message
        : "该文件不支持预览";
    }, 2000);
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    }
  },
  methods: {
    resizePreview() {
      if (this.previewData.position === "fullscreen-top") {
        this.$refs.unknowPreview.style["line-height"] =
          window.innerHeight + "px";
      } else if (this.previewData.position === "fullscreen") {
        this.$refs.unknowPreview.style["line-height"] =
          window.innerHeight - 40 + "px";
      } else if (this.previewData.position === "inside") {
        this.$refs.unknowPreview.style["line-height"] = 280 + "px";
      }
    }
  },
  mounted() {
    // console.log(this.previewData.position);
    if (this.previewData.position === "fullscreen-top") {
      this.$refs.unknowPreview.style["line-height"] = window.innerHeight + "px";
    } else if (this.previewData.position === "fullscreen") {
      this.$refs.unknowPreview.style["line-height"] =
        window.innerHeight - 40 + "px";
    } else if (this.previewData.position === "inside") {
      this.$refs.unknowPreview.style["line-height"] = 280 + "px";
    }
    window.addEventListener("resize", this.resizePreview);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizePreview);
    // console.log("销毁unknow预览组件");
  }
};
</script>

<style scoped>
.pre {
  text-align: center;
}
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>